import { IExhibitor } from "../interfaces/ILeads";
import APIService from "./API.service";
const queryString = require("query-string");

class LeadsService extends APIService {
  // Define custom headers for Leads API requests

  private leadsHeaders = {
    'fdsource': 'fdPortal',
  };
  // Get an event
  getLeadEvent(id: string) {
    return this.call.get(`${this.apiUrl}/event/${id}`,{
      headers: this.leadsHeaders
    });
  }
  // enable lead event
  enableEvent(params: any) {
    return this.call.post(`${this.apiUrl}/event`, JSON.stringify(params),{
      headers: this.leadsHeaders
    });
  }
  // Toggle lead
  tieLead(id: string) {
    return this.call.get(`${this.apiUrl}/archive/${id}/disable`,{
      headers: this.leadsHeaders
    });
  }
  // Get an exhibitor
  getExhibitors(params: any) {
    return this.call.get(`${this.apiUrl}/exhibitor/list?${queryString.stringify(params)}`,{
      headers: this.leadsHeaders
    });
  }
  // Get an exhibitor detail
  getExhibitorDetail(id: number) {
    return this.call.get(`${this.apiUrl}/exhibitor/${id}`,{
      headers: this.leadsHeaders
    });
  }
  // Get an Gdpr config settings
  updateSettings(id: string,data:any) {
    return this.call.put(`${this.apiUrl}/event/${id}/settings`,JSON.stringify(data),{
      headers: this.leadsHeaders
    });
  }
  // create exhibitor
  createExhibitor(params: IExhibitor) {
    return this.call.post(`${this.apiUrl}/exhibitor`,
    JSON.stringify(params),{
      headers: this.leadsHeaders
    });
  }
  // Update exhibitor
  updateExhibitor(id:number,params: IExhibitor) {
    return this.call.put(`${this.apiUrl}/exhibitor/${id}/details`,
    JSON.stringify(params),{
      headers: this.leadsHeaders
    });
  }
  // Bulk delete exhibitor
  deleteExhibitors(params:any) {
    return this.call.post(`${this.apiUrl}/exhibitor/delete/bulk`,
    JSON.stringify(params),{
      headers: this.leadsHeaders
    });
  }

  // update license
  updateLicense(id: number,params:any) {
    return this.call.post(`${this.apiUrl}/exhibitor/${id}/license`,
    JSON.stringify(params),{
      headers: this.leadsHeaders
    });
  }

  // resend-credentials
  resendCredential(id: number) {
    return this.call.get(`${this.apiUrl}/exhibitor/${id}/resend-credentials`,{
      headers: this.leadsHeaders
    });
  }

  // get daily report
   getSettingDetail(id:string) {
    return this.call.get(`${this.apiUrl}/event/${id}/settings`,{
      headers: this.leadsHeaders
    });
  }

  // download exhibitor list
  generateReport(reportType: string, eventId: string) {
    return this.call.post(
      `${this.apiUrl}/report/${reportType}/${eventId}/generate`,
      {},
      {
        headers: this.leadsHeaders,
      }
    );
  }
  getReport(reportId: number) {
    return this.call.get(`${this.apiUrl}/report/${reportId}`, {
      headers: this.leadsHeaders,
    });
  }
  downloadReport(reportId: number) {
    return this.call.post(
      `${this.apiUrl}/report/${reportId}/download`,
      { downloadAs: "link" },
      { headers: this.leadsHeaders }
    );
  }

  getFieldMetadata(id:string) {
    return this.call.get(`${this.apiUrl}/event/${id}/field/metadata`,{
      headers: this.leadsHeaders
    });
  }

  fieldMappings(id:string,params:any){
    return this.call.put(
      `${this.apiUrl}/event/${id}/field/mappings`,
      JSON.stringify(params),
      { headers: this.leadsHeaders }
    );

  }
}

export default LeadsService;
